var _title, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUserIndexIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "User - Index - Icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User---Index---Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "I",
    fill: "#0039CB",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "5 27 5 5 9 5 9 27"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M7.035,42.591 C7.035,43.5663382 7.5483282,44.054 8.575,44.054 C9.6016718,44.054 10.115,43.5663382 10.115,42.591 L10.115,37.465 L11.347,37.465 L11.347,42.569 C11.347,43.4563378 11.114169,44.103498 10.6485,44.5105 C10.182831,44.917502 9.48983793,45.121 8.5695,45.121 C7.64916206,45.121 6.95800231,44.917502 6.496,44.5105 C6.03399769,44.103498 5.803,43.4563378 5.803,42.569 L5.803,37.465 L7.035,37.465 L7.035,42.591 Z M15.23,38.411 C14.298662,38.411 13.833,38.7373301 13.833,39.39 C13.833,39.727335 13.9429989,39.9674993 14.163,40.1105 C14.3390009,40.2249006 14.6851313,40.3604196 15.2013987,40.5170597 L15.6205,40.6385 C16.3721704,40.847501 16.9019985,41.0968319 17.21,41.3865 C17.5180015,41.6761681 17.672,42.1326635 17.672,42.756 C17.672,43.548004 17.4465023,44.1401647 16.9955,44.5325 C16.5444977,44.9248353 15.9303372,45.121 15.153,45.121 C14.5296635,45.121 13.8403371,45.0476674 13.085,44.901 L12.689,44.824 L12.81,43.845 L13.4352363,43.9232225 C14.1241173,44.0030745 14.671035,44.043 15.076,44.043 C15.9853379,44.043 16.44,43.6396707 16.44,42.833 C16.44,42.5176651 16.3373344,42.2848341 16.132,42.1345 C15.9266656,41.9841659 15.4646703,41.8191676 14.746,41.6395 C14.0273297,41.4598324 13.4920018,41.2123349 13.14,40.897 C12.7879982,40.5816651 12.612,40.0830034 12.612,39.401 C12.612,38.7189966 12.8338311,38.2038351 13.2775,37.8555 C13.7211689,37.5071649 14.3353294,37.333 15.12,37.333 C15.6846695,37.333 16.3519961,37.3989993 17.122,37.531 L17.507,37.597 L17.408,38.587 L16.8778165,38.528818 C16.1272699,38.4502723 15.5780017,38.411 15.23,38.411 Z M23.744,37.465 L23.744,38.532 L20.213,38.532 L20.213,40.666 L23.084,40.666 L23.084,41.722 L20.213,41.722 L20.213,43.922 L23.744,43.922 L23.744,45 L18.992,45 L18.992,37.465 L23.744,37.465 Z M27.935,37.465 C29.6363418,37.465 30.487,38.2643253 30.487,39.863 C30.487,40.933672 30.0763374,41.6596648 29.255,42.041 L30.498,45 L29.156,45 L28.067,42.316 L26.296,42.316 L26.296,45 L25.075,45 L25.075,37.465 L27.935,37.465 Z M27.935,38.521 L26.296,38.521 L26.296,41.26 L27.957,41.26 C28.3970022,41.26 28.7196656,41.1335013 28.925,40.8805 C29.1303344,40.6274987 29.233,40.2920021 29.233,39.874 C29.233,38.9719955 28.8003377,38.521 27.935,38.521 L27.935,38.521 Z",
    id: "USER",
    fill: "#0039CB",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserIndexIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/User_-_Index_-_Icon.1eb434e3.svg";
export { ForwardRef as ReactComponent };